import { create } from "zustand";
import { authenticatedAxios, baseAxios, baseURL } from "../../apis";

const useBlogCategoryStore = create((set, get) => ({
  categories: [],
  loading: false,
  loadingAction: false,
  error: null,

  actions: {
    // FETCH ALL CATEGORIES
    fetchCategories: async () => {
      set({ loading: true });
      try {
        const res = await authenticatedAxios.get("/api/admin/blog-categories/");

        set({
          categories: res.data.categories.sort((a, b) =>
            a.name.localeCompare(b.name)
          ),
        });
      } catch (err) {
        console.error(err);
        set({ error: "Failed to load categories" });
      } finally {
        set({ loading: false });
      }
    },

    // ADD CATEGORY
    addCategory: async (name) => {
      set({ loadingAction: true });
      try {
        const { data } = await authenticatedAxios.post(
          `${baseURL}/api/admin/blog-categories/save`,
          { name }
        );

        set({
          categories: [...get().categories, data].sort((a, b) =>
            a.name.localeCompare(b.name)
          ),
        });

        return true;
      } catch (err) {
        console.error(err);
        return false;
      } finally {
        set({ loadingAction: false });
      }
    },

    // DELETE CATEGORY
    deleteCategory: async (id) => {
      set({ loadingAction: true });
      try {
        await authenticatedAxios.delete(
          `${baseURL}/api/admin/blog-categories/${id}/`
        );

        set({
          categories: get().categories.filter((c) => c.id !== id),
        });

        return true;
      } catch (err) {
        console.error(err);
        return false;
      } finally {
        set({ loadingAction: false });
      }
    },
  },
}));

export default useBlogCategoryStore;
